import React, { useState } from 'react';
import { formatNameForDisplay } from '../../utils/nameUtils';
import AddPlayerDropdown from './AddPlayerDropdown';
import { getPlayerNameColor } from '../../utils/playerUtils';

/**
 * Dropdown for selecting players to add to empty court slots
 * Shows available players with search functionality.
 * When readOnly is true (e.g. non-host viewer), shows a placeholder instead of "+ Add Player".
 */
const PlayerSelectionDropdown = ({
  availablePlayers = [],
  waitingManagementPlayers = [],
  sessionPlayerStatus = {},
  onSelectPlayer,
  courtNumber,
  teamNumber,
  isSocialSession = false,
  className = '',
  nextAssignments = [],
  onRemoveFromUpcoming,
  readOnly = false,
  useSinglesElo = false,
  /** Match compact court card rows */
  compact = false,
  showEloTooltip = true,
  pegBoardQueue = null,
}) => {
  const [showAddPlayerModal, setShowAddPlayerModal] = useState(false);

  const handlePlayerSelect = (playerId, courtNumber, teamNumber) => {
    if (onSelectPlayer) {
      onSelectPlayer(playerId, courtNumber, teamNumber);
    }
  };

  const handleAddGuestPlayer = () => {
    // TODO: Implement add guest player functionality
    console.log('Add guest player for court:', courtNumber, 'team:', teamNumber);
  };

  const emptySlotClass = compact
    ? 'min-h-[32px] px-1.5 py-1'
    : 'min-h-[40px] px-1.5 py-1.5 lg:min-h-[44px] lg:px-2 lg:py-2';
  const emptySlotTextClass = compact ? 'text-sm' : 'text-sm lg:text-base';

  // Read-only empty slot (player viewing, not host): same size, no button, clear message
  if (readOnly) {
    return (
      <div
        className={`flex w-full items-center justify-center rounded-md border-2 border-dashed border-border-medium bg-surface-subtle text-center ${emptySlotClass}`}
        aria-hidden
      >
        <span className={`font-medium text-text-muted ${emptySlotTextClass}`}>
          Waiting for host to add players
        </span>
      </div>
    );
  }

  // Create the trigger element (empty slot with "Add Player" text)
  const trigger = (
    <div 
      onClick={() => setShowAddPlayerModal(true)}
      className={`group relative flex w-full cursor-pointer select-none items-center justify-center rounded-md border-2 border-dashed border-border-medium bg-surface-subtle transition-all duration-200 hover:border-primary hover:bg-surface ${emptySlotClass}`}
    >
      <div className="flex items-center space-x-1 text-center">
        <span className={`font-medium text-text-muted transition-colors group-hover:text-primary ${emptySlotTextClass}`}>
          + Add Player
        </span>
      </div>
    </div>
  );

  return (
    <>
      {trigger}
      
      <AddPlayerDropdown
        isOpen={showAddPlayerModal}
        onClose={() => setShowAddPlayerModal(false)}
        onSelectPlayer={handlePlayerSelect}
        availablePlayers={availablePlayers}
        waitingManagementPlayers={waitingManagementPlayers}
        sessionPlayerStatus={sessionPlayerStatus}
        courtNumber={courtNumber}
        teamNumber={teamNumber}
        className={className}
        nextAssignments={nextAssignments}
        onRemoveFromUpcoming={onRemoveFromUpcoming}
        useSinglesElo={useSinglesElo}
        showEloTooltip={showEloTooltip}
        pegBoardQueue={pegBoardQueue}
      />
    </>
  );
};

export default PlayerSelectionDropdown;
